const CITIES = ["DALLAS", "FORT WORTH", "ARLINGTON", "FRISCO", "DENTON", "CLEBURNE", "ALLEN", "COMMERCE"];

export default function Manifesto() {
  return (
    <section className="relative overflow-hidden py-6" data-testid="manifesto-section">
      <div className="marquee-paused overflow-hidden border-y border-bline py-4">
        <div className="flex animate-marquee-slow whitespace-nowrap">
          {[...CITIES, ...CITIES].map((c, i) => (
            <span key={i} className="mx-6 font-display text-5xl tracking-wide text-outline sm:text-6xl">
              {c} <span className="text-volt" style={{ WebkitTextStroke: 0 }}>•</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
